import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import mahaLogo from './Asstes/maharashtra logo.png';
import smallLogo from './Asstes/small-logo.png';
import './portal.css';
import './modern-nav.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Handle scroll effect and body class
  useEffect(() => {
    // Add class to body when Navbar is present
    document.body.classList.add('has-floating-nav');

    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('has-floating-nav');
    };
  }, []);

  return (
    <header className={`modern-unified-nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="modern-nav-container">

        {/* LEFT: Branding / Logos */}
        <div className="modern-nav-brand">
          <Link to="/" className="brand-link">
            <div className="brand-logos">
              <img src={smallLogo} alt="ZP Logo" className="logo zplogo" />
              <img src={mahaLogo} alt="Maha Logo" className="logo mahalogo hide-on-mobile" />
            </div>
            <div className="brand-text">
              <span className="brand-title">ई-काम वाटप</span>
              <span className="brand-subtitle">जि. प. सांगली</span>
            </div>
          </Link>
        </div>

        {/* CENTER & RIGHT WRAPPER for Mobile Flex */}
        <div className={`modern-nav-menu-wrapper ${isMobileMenuOpen ? 'open' : ''}`}>

          {/* CENTER: Navigation Links */}
          <nav className="modern-nav-links">
            <ul>
              <li><Link to="/" className="modern-nav-item">🏛️ मुख्यपृष्ठ</Link></li>

              <NavDropdown label="📝 नवीन नोंदणी">
                <Link to="/engineer-registration">सु.वे. अभियंता नोंदणी</Link>
                <Link to="/society-registration">मजूर संस्था नोंदणी</Link>
              </NavDropdown>

              <NavDropdown label="🎰 लॉटरी नोंदणी">
                <Link to="/engineer-lottery-registration">सु. बे. अभियंता लॉटरी</Link>
                <Link to="/society-lottery-registration">मजुर संस्था लॉटरी</Link>
              </NavDropdown>

              <NavDropdown label="📂 नोंदणी मदत">
                <Link to="/document-list">कागदपत्रांची यादी</Link>
                <Link to="/society-document-list">नोंदणी प्रक्रिया</Link>
              </NavDropdown>
            </ul>
          </nav>

          {/* RIGHT: Action Button */}
          {/* <div className="modern-nav-actions">
            <Link to="/login" className="modern-login-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
              </svg>
              लॉगिन
            </Link>
          </div> */}
        </div>

        {/* Hamburger Toggle (Mobile Only) */}
        <button
          className="modern-mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
            )}
          </svg>
        </button>

      </div>

      {/* Mobile Menu Overlay overlay */}
      <div
        className={`modern-nav-overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

    </header>
  );
};

// Custom Dropdown for the Modern Nav
const NavDropdown = ({ label, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <li
      className={`modern-dropdown ${open ? 'open' : ''}`}
      onMouseEnter={() => window.innerWidth > 900 && setOpen(true)}
      onMouseLeave={() => window.innerWidth > 900 && setOpen(false)}
    >
      <button 
        className="modern-nav-item modern-dropdown-trigger" 
        style={{ width: '100%' }}
        onClick={(e) => {
          e.preventDefault();
          setOpen(!open);
        }}
      >
        {label}
        <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
          <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div className="modern-dropdown-menu">{children}</div>
    </li>
  );
};

export default Navbar;
